import { ButtonHTMLAttributes, FC } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { UserProfile } from '../../../types/graphql';
import { TextButton } from '../../atoms/button/Button';
import { Icon } from '../../atoms/icon/Icon';

export interface AuthorProps {
  link?: boolean;
  loading?: boolean;
  onRemove?: () => void;
  profile: Pick<UserProfile, 'avatar' | 'display_name' | 'slug'>;
  removable?: boolean;
}

export const Author: FC<AuthorProps & ButtonHTMLAttributes<HTMLButtonElement | HTMLDivElement>> = ({
  link,
  loading,
  onKeyDown,
  onRemove,
  profile,
  ...props
}) => (
  <div
    onKeyDown={onKeyDown}
    tabIndex={link ? 0 : undefined}
    role={link ? 'button' : undefined}
    css={[
      (link || onRemove) && tw`hocus:bg-gray-15`,
      link && tw`cursor-pointer`,
      { '&:hover .icon, &:active .icon, &:focus .icon': { display: 'inline-block' } },
    ]}
    tw="bg-white flex items-center outline-none rounded-full leading-none p-half pr-2"
    {...props}
  >
    <img src={profile?.avatar || ''} alt="avatar" tw="rounded-full w-6 h-6 mr-1" />
    <div>
      <div tw="font-normal text-lg">{profile?.display_name}</div>
      {profile?.slug && <div tw="text-sm font-medium text-secondary">@{profile.slug}</div>}
    </div>
    <div tw="flex-grow" />
    {onRemove &&
      (loading ? (
        <Icon name="circle-loader" tw="text-xl font-normal animate-spin" />
      ) : (
        <TextButton onClick={onRemove}>
          <Icon name="remove-user" tw="text-secondary text-xl font-normal hidden" />
        </TextButton>
      ))}
    {link && <Icon name="circle-add" tw="text-secondary text-2xl font-normal hidden" />}
  </div>
);
